// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5l-6";
export var headerCell = "_5l-2";
export var rowWrapper = "_5l-4";
export var stickyAggregationCell = "_5l-a";
export var stickyAggregationRow = "_5l-7";
export var stickyColumnCell = "_5l-9";
export var stickyColumnHeaderCell = "_5l-8";
export var table = "_5l-1";
export var virtualRowWrapper = "_5l-5";
export var virtualTableContainer = "_5l-0";
export var white = "_5l-3";